import { render, staticRenderFns } from "./CenterHoliday.vue?vue&type=template&id=4fb8fbac&"
import script from "./CenterHoliday.vue?vue&type=script&lang=js&"
export * from "./CenterHoliday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports